import React, {Component} from 'react';
import PropTypes from 'prop-types';
import "../common/wysiwyg.scss";
import './gridItem.scss';
import '../common/input.scss';
import ToggleButton from 'react-toggle-button'

class GridItem extends Component {

	numberSelector() {
		const { statePosition,  index, value,  changeHandler, decrementHandler, incrementHandler } = this.props;
		return (
			<form onSubmit={(event) => {event.preventDefault();}}>
				<button type="button" onClick={() => {decrementHandler(statePosition, index)}}>-</button>
				<input type='number' value={value} onChange={(event) => changeHandler(event.target.value, statePosition, index)} className="field" min='0' />
				<button type="button" onClick={() => {incrementHandler(statePosition, index)}}>+</button>
			</form>);
	}


	toggleSelector() {
		const { statePosition, index, value, changeHandler} = this.props;
	return (
		<div className="toggleButton">
		<span className="toggleButton-off">No</span>
		<ToggleButton value={ value || 0 }
		onToggle={(value) => {
			value = value === 0 ? 1 : 0;
			changeHandler(value, statePosition, index);}}
		inactiveLabel=""
		activeLabel=""
		colors={{
			activeThumb: {
				base: '#064a76',
			},
			inactiveThumb: {
				base: 'rgb(250,250,250)',
			},
			active: {
				base: 'rgb(207, 221, 245)',
			},
			inactive: {
				base: 'rgb(65,66,68)',
			}
		}}
		trackStyle={{
			height: 26,
		}}
		thumbStyle={{
			position: 'absolute',
			width: 22,
			height: 22,
			boxShadow: `0 0 2px rgba(0,0,0,.12),0 2px 4px rgba(0,0,0,.24)`
		}}
		thumbAnimateRange={[2, 28]} />
		<span className="toggleButton-on">Yes</span>
		</div>
	);
	}

	innerds() {
		const { title, subTitle, content, statePosition, costBasis, image, index, open, selectionHandler } = this.props;
		return (
		<div className="expanded">
			<div className='flex'>
				{image && <img src={image} alt={title} title={title} />}
				<div className="increment-description-block">
					<h3>{title}</h3>
					{subTitle && <p>{subTitle}</p>}
					<div className="wysiwyg" dangerouslySetInnerHTML={{__html: content}} />
					{costBasis === "unit" ? this.numberSelector() : this.toggleSelector()}
				</div>
			</div>
		</div>);
	}

	render() {

		return (
			<div className="gridItem">
				{this.innerds()}
			</div>
		);
	}
};

GridItem.propTypes = {
	title: PropTypes.string
}

export default GridItem;



// WEBPACK FOOTER //
// ./src/components/step/GridItem.js